var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "任务标题", prop: "title" } },
        [
          _c("el-input", {
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务图标", prop: "icon" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "icon-uploader",
              attrs: {
                size: "mini",
                action: "#",
                "list-type": "picture-card",
                limit: 1,
                "show-file-list": false,
                "http-request": _vm.handleCustomUpload,
              },
            },
            [
              _vm.form.icon
                ? _c("img", {
                    staticClass: "uploaded-icon",
                    attrs: { src: _vm.form.icon },
                  })
                : _c("i", { staticClass: "el-icon-plus" }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务类型 / 周期", required: "" } },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { disabled: !!_vm.form.id, placeholder: "请选择" },
                  on: { change: _vm.handleTaskTypeChange },
                  model: {
                    value: _vm.form.taskType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taskType", $$v)
                    },
                    expression: "form.taskType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "单次", value: "single" },
                  }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "循环", value: "cycle" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.taskType === "cycle"
                ? [
                    _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "20px", width: "120px" },
                        attrs: {
                          placeholder: "请选择周期",
                          disabled: !!_vm.form.id,
                        },
                        on: { change: _vm.taskTypeChange },
                        model: {
                          value: _vm.form.cycleDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cycleDays", $$v)
                          },
                          expression: "form.cycleDays",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "按年", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按季", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按月", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按周", value: "3.2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按日", value: "4" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.cycleDays
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              "font-size": "12px",
                              color: "#333",
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "#409eff" } }, [
                              _vm._v("周期说明："),
                            ]),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.cycleExplain[_vm.form.cycleDays]) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励发放", prop: "grant" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small", disabled: "" },
              model: {
                value: _vm.form.grant,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "grant", $$v)
                },
                expression: "form.grant",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("实时")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("隔天")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "规则", prop: "ruleCode" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择规则", disabled: !!_vm.form.id },
                on: { change: _vm.handleRuleChange },
                model: {
                  value: _vm.form.ruleCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ruleCode", $$v)
                  },
                  expression: "form.ruleCode",
                },
              },
              _vm._l(_vm.ruleOptions2, function (item) {
                return _c("el-option", {
                  key: item.ruleCode,
                  attrs: { label: item.ruleName, value: item.ruleCode },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.selectedRuleText && _vm.form.ruleCode
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      color: "#333",
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#409eff" } }, [
                      _vm._v("规则说明："),
                    ]),
                    _vm._v(
                      "\n        " + _vm._s(_vm.selectedRuleText) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.ruleCode == "c" && _vm.form.taskType === "cycle"
          ? _c(
              "div",
              { staticClass: "rule-extra-panel" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单数 ≥" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0, size: "small", disabled: !!_vm.form.id },
                      model: {
                        value: _vm.ruleForm.orderCount,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "orderCount", $$v)
                        },
                        expression: "ruleForm.orderCount",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "消费天数 ≥" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0, size: "small", disabled: !!_vm.form.id },
                      model: {
                        value: _vm.ruleForm.consumeDays,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "consumeDays", $$v)
                        },
                        expression: "ruleForm.consumeDays",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "消费金额 ≥（元）" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        size: "small",
                        step: 1,
                        disabled: !!_vm.form.id,
                      },
                      model: {
                        value: _vm.ruleForm.amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "amount", $$v)
                        },
                        expression: "ruleForm.amount",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "消费类型" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "small", disabled: !!_vm.form.id },
                        model: {
                          value: _vm.ruleForm.consumeType,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "consumeType", $$v)
                          },
                          expression: "ruleForm.consumeType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("连续消费"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 2 } }, [
                          _vm._v("累计消费"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.taskType === "cycle" && _vm.form.ruleCode === "g"
          ? _c(
              "div",
              { staticClass: "rule-extra-panel" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "发帖（打卡）数 ≥" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        size: "small",
                        step: 1,
                        disabled: !!_vm.form.id,
                      },
                      model: {
                        value: _vm.ruleForm.commentCount,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "commentCount", $$v)
                        },
                        expression: "ruleForm.commentCount",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.ruleCode == "d" && _vm.form.taskType === "cycle"
          ? _c(
              "div",
              { staticClass: "rule-extra-panel" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "累计充值 ≥" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        step: 0.01,
                        precision: 2,
                        size: "small",
                        disabled: !!_vm.form.id,
                      },
                      model: {
                        value: _vm.ruleForm.rechargeAmt,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "rechargeAmt", $$v)
                        },
                        expression: "ruleForm.rechargeAmt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "需使用余额" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          "true-label": 1,
                          "false-label": 0,
                          disabled: !!_vm.form.id,
                        },
                        model: {
                          value: _vm.ruleForm.useBalance,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "useBalance", $$v)
                          },
                          expression: "ruleForm.useBalance",
                        },
                      },
                      [_vm._v("\n         使用余额\n       ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.ruleCode === "e" && _vm.form.taskType === "cycle"
          ? _c(
              "div",
              { staticClass: "rule-extra-panel" },
              [
                !_vm.form.id
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "rule-extra-label",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: { label: "范围", "label-width": "80px" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "mini", disabled: !!_vm.form.id },
                            on: { change: _vm.onRangeTypeChange },
                            model: {
                              value: _vm.ruleForm.rangeType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "rangeType", $$v)
                              },
                              expression: "ruleForm.rangeType",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 0 } }, [
                              _vm._v("按商品"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio-button", { attrs: { label: 1 } }, [
                              _vm._v("按分类"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.form.id
                  ? _c(
                      "div",
                      [
                        _vm.ruleForm.rangeType === 0
                          ? _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-right": "10px",
                                  },
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请输入商品关键词",
                                  },
                                  model: {
                                    value: _vm.productQuery,
                                    callback: function ($$v) {
                                      _vm.productQuery = $$v
                                    },
                                    expression: "productQuery",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: { click: _vm.searchProducts },
                                  },
                                  [_vm._v("查询")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ruleForm.rangeType === 0
                          ? _c(
                              "el-form-item",
                              [
                                _c("el-transfer", {
                                  attrs: {
                                    data: _vm.productOptions,
                                    props: {
                                      key: "id",
                                      label: "goodsName",
                                    },
                                    titles: ["可选商品列表", "已选商品列表"],
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var option = ref.option
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: option.goodsName,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "transfer-item-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(option.goodsName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1116431878
                                  ),
                                  model: {
                                    value: _vm.form.typeIdList,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "typeIdList", $$v)
                                    },
                                    expression: "form.typeIdList",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ruleForm.rangeType === 1
                          ? _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-right": "10px",
                                  },
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请输入分类关键词",
                                  },
                                  model: {
                                    value: _vm.categoryQuery,
                                    callback: function ($$v) {
                                      _vm.categoryQuery = $$v
                                    },
                                    expression: "categoryQuery",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: { click: _vm.searchCategories },
                                  },
                                  [_vm._v("查询")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ruleForm.rangeType === 1
                          ? _c(
                              "el-form-item",
                              [
                                _c("el-transfer", {
                                  attrs: {
                                    data: _vm.categoryOptions,
                                    props: { key: "id", label: "categoryName" },
                                    titles: ["可选分类列表", "已选分类列表"],
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var option = ref.option
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: option.categoryName,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "transfer-item-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        option.categoryName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2326055750
                                  ),
                                  model: {
                                    value: _vm.form.typeIdList2,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "typeIdList2", $$v)
                                    },
                                    expression: "form.typeIdList2",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.id
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "rule-extra-label",
                            attrs: {
                              label:
                                _vm.ruleForm.rangeType === 1
                                  ? "指定分类："
                                  : "指定商品：",
                              "label-width": "80px",
                            },
                          },
                          [
                            _vm._l(_vm.form.names, function (s, index) {
                              return _vm.ruleForm.rangeType === 1
                                ? _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticStyle: { "margin-right": "6px" },
                                      attrs: {
                                        type: "info",
                                        size: "mini",
                                        effect: "light",
                                      },
                                    },
                                    [_vm._v("\n    " + _vm._s(s) + "\n  ")]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.form.goodsNames, function (s, index) {
                              return _vm.ruleForm.rangeType === 0
                                ? _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticStyle: { "margin-right": "6px" },
                                      attrs: {
                                        type: "info",
                                        size: "mini",
                                        effect: "light",
                                      },
                                    },
                                    [_vm._v("\n    " + _vm._s(s) + "\n  ")]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "rule-extra-label",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-top": "10px",
                    },
                    attrs: { label: "条件", "label-width": "80px" },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "mini", disabled: !!_vm.form.id },
                        model: {
                          value: _vm.ruleForm.countType,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "countType", $$v)
                          },
                          expression: "ruleForm.countType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("满足购买指定商品的数量"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("满足含有指定商品的订单数量"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ruleForm.countType === 0 || _vm.ruleForm.countType === 1
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "rule-extra-label",
                        attrs: {
                          "label-width": "80px",
                          label:
                            _vm.ruleForm.countType === 0
                              ? "商品数量 ≥"
                              : "订单数量 ≥",
                        },
                      },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            size: "mini",
                            disabled: !!_vm.form.id,
                          },
                          model: {
                            value: _vm.ruleForm.typeIdCount,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "typeIdCount", $$v)
                            },
                            expression: "ruleForm.typeIdCount",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励类型", prop: "rewardType" } },
        [
          _c(
            "el-select",
            {
              attrs: { disabled: !!_vm.form.id },
              on: { change: _vm.handleRewardTypeChange },
              model: {
                value: _vm.form.rewardType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "rewardType", $$v)
                },
                expression: "form.rewardType",
              },
            },
            [
              _c("el-option", { attrs: { label: "积分", value: "points" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "礼券", value: "coupon" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励内容", prop: "rewardValue" } },
        [
          _vm.form.rewardType === "points"
            ? _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: {
                  type: "number",
                  min: 1,
                  placeholder: "请输入积分",
                  disabled: !!_vm.form.id,
                },
                model: {
                  value: _vm.form.rewardValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rewardValue", _vm._n($$v))
                  },
                  expression: "form.rewardValue",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.rewardType === "coupon"
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    placeholder: "请输入礼券，支持模糊查询",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.fetchCoupons,
                    loading: _vm.couponLoading,
                    disabled: !!_vm.form.id,
                  },
                  model: {
                    value: _vm.form.rewardValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "rewardValue", $$v)
                    },
                    expression: "form.rewardValue",
                  },
                },
                _vm._l(_vm.couponOptions, function (coupon) {
                  return _c("el-option", {
                    key: coupon.typeId,
                    attrs: { label: coupon.typeName, value: coupon.typeId },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务状态", prop: "status" } },
        [
          _c(
            "el-select",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-option", { attrs: { label: "下架", value: 0 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "上架", value: 1 } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务描述", prop: "description" } },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              placeholder: "请输入任务描述，为空显示规则说明！",
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "排序值", prop: "sortOrder" } },
        [
          _c("el-input-number", {
            staticStyle: { width: "150px" },
            attrs: { min: 0, controls: false, placeholder: "越小越靠前" },
            model: {
              value: _vm.form.sortOrder,
              callback: function ($$v) {
                _vm.$set(_vm.form, "sortOrder", $$v)
              },
              expression: "form.sortOrder",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }